import { atom, useAtomValue } from "jotai"
import { useMemo } from "react"
import { currentPhotoAtom, selectedPhotosIDsAtom } from "@/store/photo/photos-state"
import { PhotoRecord } from "@/lib/catalog"

export const useIsPrimarySelection = (photoId: PhotoRecord["id"]) => {
	const isPrimaryAtom = useMemo(
		() =>
			atom((get) => {
				const currentPhoto = get(currentPhotoAtom)
				return currentPhoto?.id === photoId
			}),
		[photoId],
	)

	return useAtomValue(isPrimaryAtom)
}

export const useIsSecondarySelection = (photoId: PhotoRecord["id"]) => {
	const isSecondaryAtom = useMemo(
		() =>
			atom((get) => {
				return get(selectedPhotosIDsAtom).has(photoId)
			}),
		[photoId],
	)

	return useAtomValue(isSecondaryAtom)
}
